module.exports = __webpack_public_path__ + "static/img/bingli2.f1a3206e.webp";